import { render } from "./Services.vue?vue&type=template&id=d8b6ebec&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=d8b6ebec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8b6ebec"]])

export default __exports__